const carouselItems = [
  {
    title: '《暗夜追踪》独家专访',
    desc: '导演携主演深度解读创作幕后，揭秘悬疑剧本的灵感来源与拍摄过程中的精彩花絮。',
    img: 'https://readdy.ai/api/search-image?query=A%20cinematic%20film%20interview%20scene%20with%20warm%20amber%20studio%20lighting%2C%20director%20and%20actors%20silhouette%2C%20dramatic%20atmosphere%2C%20film%20production%20aesthetic%2C%20professional%20cinematography%20style&width=800&height=450&seq=carousel-01&orientation=landscape',
    tag: '独家专访',
  },
  {
    title: '暑期档票房预测与分析',
    desc: '数据解读今年暑期档电影市场格局，蚂蚁影视带你前瞻热门影片的票房表现与口碑走势。',
    img: 'https://readdy.ai/api/search-image?query=A%20cinematic%20box%20office%20theme%20scene%20with%20warm%20golden%20lights%2C%20abstract%20movie%20theater%20atmosphere%2C%20glowing%20cinema%20marquee%2C%20professional%20photography%2C%20dramatic%20lighting&width=800&height=450&seq=carousel-02&orientation=landscape',
    tag: '行业分析',
  },
  {
    title: '经典电影配乐赏析特辑',
    desc: '汉斯·季默、坂本龙一等大师级配乐合集，带你重温那些刻在DNA里的经典旋律与画面。',
    img: 'https://readdy.ai/api/search-image?query=A%20cinematic%20music%20composition%20scene%20with%20warm%20golden%20lighting%2C%20orchestra%20silhouette%2C%20film%20score%20sheet%20music%2C%20dramatic%20atmosphere%2C%20elegant%20concert%20hall%20aesthetic&width=800&height=450&seq=carousel-03&orientation=landscape',
    tag: '音乐特辑',
  },
  {
    title: '国产动画2026年中盘点',
    desc: '从《山海经异兽录》到《深海2》，蚂蚁影视为你盘点今年最值得关注的国产动画作品。',
    img: 'https://readdy.ai/api/search-image?query=A%20cinematic%20Chinese%20animation%20scene%20with%20warm%20amber%20glow%2C%20mythical%20creatures%20in%20artistic%20style%2C%20rich%20golden%20and%20coral%20tones%2C%20fantasy%20atmosphere%2C%20beautiful%20composition&width=800&height=450&seq=carousel-04&orientation=landscape',
    tag: '年度盘点',
  },
  {
    title: '电影冷知识：你不知道的幕后',
    desc: '那些经典镜头背后的秘密，特效制作的神奇手法，以及电影史上最有趣的拍摄趣闻一网打尽。',
    img: 'https://readdy.ai/api/search-image?query=A%20behind%20the%20scenes%20film%20production%20scene%20with%20warm%20golden%20lighting%2C%20vintage%20camera%20equipment%2C%20cinematic%20atmosphere%2C%20film%20set%20aesthetic%2C%20professional%20photography%20style&width=800&height=450&seq=carousel-05&orientation=landscape',
    tag: '冷知识',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 font-heading">
            焦点推荐
          </h2>
          <p className="mt-3 text-foreground-400 text-sm">
            编辑精选的深度内容与特别策划
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-100 border border-background-300/30 rounded-xl overflow-hidden hover:border-primary-500/30 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={item.img}
                  alt={`蚂蚁影视 ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  width="800"
                  height="450"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 text-[11px] font-medium bg-primary-500 text-background-950 rounded-md">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 flex flex-col flex-1">
                <h3 className="text-sm font-semibold text-foreground-100 group-hover:text-primary-400 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-3 flex-1">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}